import {
  GET_API_LOGS,
  GET_API_LOG_DETAILS,
  API_LOGS_LIST,
} from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";
const apiLogsSlice = createCrudSlice({
  name: "apiLogs",
  urls: {
    getList: GET_API_LOGS,
    getDropdownList: API_LOGS_LIST,
    getDetails: GET_API_LOG_DETAILS,
  },
  initialFilters: {},
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {},
  initialState: {
    url: "",
    responseStatus: 0,
  },
});

// Export actions
export const { setFilter, resetFilters } = apiLogsSlice.actions;

// Export thunks
export const {
  getList: getAPILogsList,
  getDropdownList: getApiUrlDropdownlist,
  getDetails: getAPILogDetails,
} = apiLogsSlice.thunks;

// Export reducer
export default apiLogsSlice.reducer;
